import api from "./core";
const basePath = "api/core/ToDoItem";

export default {
  create(data) {
    return api.put(`${basePath}/`, data);
  },
  query(filter, extraHeaders = {}) {
    return api.post(`${basePath}/`, filter, extraHeaders);
  },
  dismiss(id) {
    return api.put(`${basePath}/${id}`);
  },
  getStatus(id) {
    return api.get(`${basePath}/${id}/Status`);
  }
};
